export default __webpack_public_path__ + "static/media/logo-new.fad6015c.png";